import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import type { MediaAgentPoolConfigDto } from '@/types/dtos/media-agent/media-agent-pool.dto';

export const MEDIA_AGENT_POOL_CONFIG_QUERY_KEY = 'media-agent-pool-config';

export function useMediaAgentPoolConfigQuery({ enabled = true }: { enabled?: boolean } = {}) {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: [MEDIA_AGENT_POOL_CONFIG_QUERY_KEY],
    enabled,
    queryFn: async () => {
      const token = (await getToken()) ?? '';
      const url = `${import.meta.env.VITE_API_URL}/media-agent/pool-config`;
      const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok) throw new Error('Failed to load media agent pool config');
      const json = (await res.json()) as { config: MediaAgentPoolConfigDto };
      return json.config;
    },
  });
}
